import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '@material-ui/core'
import { noop } from 'lodash'

import api from 'common/api'

import RegisterModal from './RegisterModal'

export class Modal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    eventId: PropTypes.string.isRequired,
    highSchoolName: PropTypes.string.isRequired,
    onEventChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    allowRepMeeting: PropTypes.bool,
    placeName: PropTypes.string,
  }
  static defaultProps = {
    show: false,
  }
  request = (placeName) => {
    const { eventId, onClose, onEventChange } = this.props
    const requestBody = placeName === this.props.placeName ? {} : { PlaceName: placeName }
    api
      .post(`/api/highschools/visits/${eventId}/register`, requestBody)
      .then(() => {
        onEventChange()
        onClose()
      })
      .catch(noop)
  }
  render() {
    return (
      <RegisterModal
        show={this.props.show}
        title="Confirm Request"
        onConfirm={this.request}
        onClose={this.props.onClose}
        allowRepMeeting={this.props.allowRepMeeting}
        placeName={this.props.placeName}
      >
        <div className="shared-information-label">
          <strong>{this.props.highSchoolName}</strong> requires approval for all visit requests. You will be notified of
          the outcome of your request.
        </div>
      </RegisterModal>
    )
  }
}
export class Trigger extends React.Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
  }
  render() {
    return (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={() => this.props.onOpen()}
      >
        Send Registration Request
      </Button>
    )
  }
}
